import { Component } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { BusqUsuario, HttpPaginacionBusqueda } from 'src/app/models/http-paginacion-busqueda.interface';
import { Paginar } from 'src/app/models/http-paginacion.interface';
import { AdministradorService } from 'src/app/services/administrador.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-administrador-medicos',
  templateUrl: './administrador-medicos.component.html',
  styleUrls: ['./administrador-medicos.component.scss']
})
export class AdministradorMedicosComponent {
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 120;
  busquedaForm!: FormGroup;

  medicoPageInformacion: HttpPaginacionBusqueda<BusqUsuario> | undefined;
  medicoPage: BusqUsuario[] = [];

  constructor(private administradorService: AdministradorService, private fb: FormBuilder) {
    this.busquedaForm = this.crearFormBusqueda();
    this.obtenerInformacion(1)
  }

  crearFormBusqueda(): FormGroup {
    return this.fb.group({
      nombre: [''],
      apellido_paterno: [''],
      apellido_materno: ['']
    });
  }

  onSubmit(): void {
    this.obtenerInformacion(1);
  }

  obtenerInformacion(page: number): void {

    const busqueda = this.busquedaForm.value;

    this.administradorService
      .busquedaMedicos(busqueda, page)
      .subscribe({
        next: (resp) => {
          this.medicoPageInformacion = resp;
          this.medicoPage = resp.data;
          this.first = (resp.current_page - 1) * resp.per_page;
          this.rows = resp.per_page;
          this.totalRecords = resp.total;
        },
        error: (err) => { console.log(err.error) }
      })

  }

  onPageChange(event: any) {
    const paginar: Paginar = <Paginar>event;
    const paginaActual = paginar.page + 1;
    this.obtenerInformacion(paginaActual);
  }

  exportExcel(): void {
    const url = environment.urlBackPublic + environment.xlsxs.datosGeneralesMedicos;
    window.open(url, "_blank");
  }
}
